module.exports = __webpack_public_path__ + "media/images/career_camp/2023/landscape_item_3-49ee058f5531bb8757a5ef4fcb15a60c.png";